import { byPrefixAndName } from '@awesome.me/kit-5c288c4b3f/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { CardCtaProps } from '../types'
import { Button } from './Button'
import { BlackWrapper } from './Sections'
import { H3, H4 } from './Typography'
import { classNames } from '../utils'

export const CardCta = ({
  cta,
  customClasses,
  description,
  icon,
  name,
  order,
  slug,
}: CardCtaProps) => {
  return (
    <div
      className={classNames(
        'mb-7 flex flex-col',
        customClasses,
        `order-${order}`
      )}
    >
      <BlackWrapper>
        <FontAwesomeIcon
          className="mb-xxl text-default-50"
          size="2x"
          icon={byPrefixAndName.fal[icon]}
        />
        <H3 customClasses="text-primary">{name}</H3>
        <H4>{description}</H4>
        <div className="mt-auto">
          <Button to={`${slug}`}>
            {cta ? cta : 'Learn more'}{' '}
            <span className="sr-only">about {name}</span>
          </Button>
        </div>
      </BlackWrapper>
    </div>
  )
}
